import { HTTPError } from '@ixigo/shell/fetch';

export const SOMETHING_WENT_WRONG = 'Something went wrong. Please try again.';

/** A failed API call: `message` is for the creator, `code` (the API's error code) for logic. */
export class ApiError extends Error {
	constructor(
		message: string,
		readonly code: string | null = null,
	) {
		super(message);
		this.name = 'ApiError';
	}
}

/** Error bodies: creator-platform's `{ error_code, message }`, the user API's `{ errors }`. */
type ErrorBody = {
	error_code?: string;
	message?: string;
	errors?: { message?: string } | null;
};

/**
 * Any failure as an `ApiError`, with the API's message when its error body has
 * one, `fallback` otherwise (network failure, unexpected body).
 */
export async function toApiError(
	error: unknown,
	fallback: string,
): Promise<ApiError> {
	const body =
		error instanceof HTTPError
			? ((await error.response
					.clone()
					.json()
					.catch(() => null)) as ErrorBody | null)
			: null;
	return new ApiError(
		body?.message || body?.errors?.message || fallback,
		body?.error_code ?? null,
	);
}
